module.exports = __webpack_public_path__ + "assets/illu-badge.c327d7b525c332222135d8cf8dd69aa2.svg";